import { Flex, HoverCard, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

interface LabeledInputProps {
  label: string;
  helperText: string;
}

export const LabeledInput = ({ label, helperText }: LabeledInputProps) => {
  return (
    <Flex gap={4} align="center">
      <Text size="sm">{label}</Text>
      <HoverCard width={250} position="right" shadow="md" radius="lg">
        <HoverCard.Target>
          <IconInfoCircle size={16} color="#0077cc" stroke={2.5} />
        </HoverCard.Target>
        <HoverCard.Dropdown bg="black">
          <Text size="sm" c="white" fw={500}>
            {helperText}
          </Text>
        </HoverCard.Dropdown>
      </HoverCard>
    </Flex>
  );
};

export default LabeledInput;
